import React from 'react';
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { StyleSheet } from 'aphrodite';
import thunkMiddleware from 'redux-thunk';

import Header, { isFloating, withSearch } from './components/Header/Header.jsx';
import Search from './pages/Search/Search.jsx';
import reducer from './pages/Search/reducers';
import qs from 'qs';

import { fetchActions } from './pages/Search/actions';

const SearchHeader = withSearch(isFloating(Header));

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__;
const preloadedClasses = window.__PRELOAD_CLASSES__;
// const configVariables = window.__CONFIG__;

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__;
delete window.__PRELOAD_CLASSES__;
delete window.__CONFIG__;

const store = createStore(reducer, preloadedState, applyMiddleware(thunkMiddleware));

StyleSheet.rehydrate(preloadedClasses);

const fetchSearchResults = () => {
    const state = store.getState();
    const params = window.location.search.split('?')[1];
    const location = decodeURIComponent(window.location.pathname.split('/')[4]);
    const tag = {
        quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
    };
    const paramsObj = qs.parse(params);
    const paramsString = qs.stringify(paramsObj);
    const url = `${
        window.location.origin
    }/${
        window.location.pathname.split('/')[1]
    }/${
        window.location.pathname.split('/')[2]
    }/${
        tag.quick_slug
    }/${
        location
    }?${
        paramsString
    }`;
    window.history.pushState({
        apiUrl: state.apiUrl,
        location,
        tag,
        paramsString,
        trackingCookieId: state.trackingCookieId
    }, null, url);
    return store.dispatch(
        fetchActions.fetchSearchResults(
            state.config.apiUrl,
            state.config.userLang,
            location,
            tag,
            paramsString,
            state.config.trackingCookieId,
            true,
            false,
            true
        )
    );
};

fetchSearchResults();
//     .then(() => {
//         render(
//             <Provider store={store}>
//                 <div>
//                     <SearchHeader />
//                     <Search />
//                 </div>
//             </Provider>,
//             document.getElementById('root')
//         );
// });

render(
    <Provider store={store}>
        <div>
            <SearchHeader />
            <Search />
        </div>
    </Provider>,
    document.getElementById('root')
);

function change(newState) {
    if (newState !== null) {
        store.dispatch(
            fetchActions.fetchSearchResults(
                newState.config.apiUrl,
                newState.config.userLang,
                newState.location,
                newState.tag,
                qs.stringify(newState.params, { arrayFormat: 'brackets' }),
                newState.config.trackingCookieId,
                true,
                false,
                true
            )
        );
    }
}

$(window).on('popstate', (e) => {
    change(e.originalEvent.state);
});



// WEBPACK FOOTER //
// ./src/search.js